export default "__VITE_ASSET__C0c1O8PF__"